import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ROUTE from "../../../api-services/routes.config.json";
import styles from "./styles.module.css";

export default function BreadCrumbs() {
  const navigate = useNavigate();
  const location = useLocation();

  // Split the pathname and filter out empty segments
  const paths = location.pathname.split("/").filter(Boolean);

  let breadcrumbs = [];
  let routes = [];

  // When there is only one segment (the journal title), show "Archives / [journal title]"
  if (paths.length === 1) {
    breadcrumbs = ["Archives", paths[0]];
    // Force Archives route to be absolute
    routes = [`/${ROUTE.ARCHIVES}`, location.pathname];
  } else {
    // Fallback: use the path segments directly
    breadcrumbs = paths;
    routes = paths.map((_, index) => `/${paths.slice(0, index + 1).join("/")}`);
  }

  return (
    <div className={styles.breadcrumbs_container}>
      {breadcrumbs.map((crumb, index) => (
        <p
          key={index}
          className={styles.breadcrumbs}
          onClick={() => {
            if (routes[index]) {
              navigate(routes[index]);
            }
          }}
        >
          <span
            className={
              index === breadcrumbs.length - 1 ? styles.active_breadcrumb : ""
            }
          >
            {crumb}
          </span>
          {index !== breadcrumbs.length - 1 && " / "}
        </p>
      ))}
    </div>
  );
}
